module.exports = __webpack_public_path__ + "static/header_home-4e794d67d6c28838cc2c3112717cce9c.jpg";